import React from "react"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

interface SolidIconProps {
  icon: IconDefinition
}

/**
 * Draws a Font Awesome icon from its definition, in the current text colour and sized to the text.
 *
 * `FontAwesomeIcon` itself (react-fontawesome 0.1) sets `defaultProps` on a function component,
 * which React 18.3 warns about, and the dev server turns into a full-screen error overlay.
 */
export const SolidIcon: React.FC<SolidIconProps> = ({
  icon: {
    icon: [width, height, , , path],
  },
}) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={`${width / height}em`}
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d={Array.isArray(path) ? path.join(" ") : path} />
  </svg>
)
